import moment from 'moment-jalaali';
import { formatJalaliDateForApi, persianToEnglishDigits } from './workFilterUtils';

/** استخراج لیست انواع قرارداد از پاسخ‌های مختلف API */
export const parseContractTypesList = (res) => {
  if (!res) return [];
  if (Array.isArray(res)) return res;
  if (Array.isArray(res.data)) return res.data;
  if (Array.isArray(res.contract_types)) return res.contract_types;
  if (Array.isArray(res.data?.contract_types)) return res.data.contract_types;
  return [];
};

const DEFAULT_DATE_KEYS = ['start_date', 'due_date', 'deadline', 'end_date'];

/** تبدیل فیلدهای تاریخ فرم به فرمت API: 1405/03/04 */
export const applyWorkFormDates = (payload, extraKeys = []) => {
  const out = { ...payload };
  [...DEFAULT_DATE_KEYS, ...extraKeys].forEach((key) => {
    if (!(key in out) || out[key] == null || out[key] === '') return;
    const formatted = formatJalaliDateForApi(out[key]);
    if (formatted !== undefined) out[key] = formatted;
    else delete out[key];
  });
  return out;
};

export { formatJalaliDateForApi, persianToEnglishDigits };
